import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { PppProfileProvider } from "../contexts/PppProfileContext";
import { DialogProvider } from "../contexts/DialogContext";
import { MkIpPoolProvider } from "../contexts/MkIpPoolContext";
import { NasProvider } from "../contexts/NasContext";

export const PppProfileComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <PppProfileProvider key={0} />,
        <MkIpPoolProvider key={1} />,
        <NasProvider key={2} />,
        <DialogProvider key={3} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
